import Button from 'theme/Button'
import i18n from 'utils/i18n'
import React, { useEffect } from 'react'
import { FormStatus } from 'utils/constants/form-constants';
import ReactTimeout from 'react-timeout'
import _ from 'lodash'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import isEqual from 'react-fast-compare'
import { colorStyles } from 'styles/colors'

const FormSubmitButton = ({ formStatus, disabled, onPress, style = {}, children, formStatusCallback, testID }) => {
	
	useEffect( () => {
		if( [ FormStatus.ERROR, FormStatus.SUCCESS ].includes( formStatus ) ) {
			if( _.isFunction( formStatusCallback ) ) {
				setTimeout( () => {
					return formStatusCallback(FormStatus.NONE);
				}, 1500 )
			}
		}
	}, [ formStatus ])
	
	const buttonProps = {
		style: style,
		isLoading: formStatus === FormStatus.LOADING,
		onPress: onPress,
		disabled: disabled,
		testID: testID
	}
	
	if( formStatus === FormStatus.ERROR ) {
		return (
			<Button
				{ ...buttonProps }>
				
				{ i18n.t( 'management:form.save' ) }
			</Button>
		)
	}
	
	if( formStatus === FormStatus.SUCCESS ) {
		return (
			<Button
				style={ style }
				status={"success"}
				icon={ <Icon icon={ IconSystemConstants.SUCCESS } style={ colorStyles.white } /> }>
				
				{ i18n.t( 'management:form.saved' ) }
			</Button>
		)
	}
	
	return (
		<Button
			{ ...buttonProps }>
			
			{ children ?? i18n.t( 'management:form.save' ) }
		</Button>
	)
}

export default React.memo( ReactTimeout( FormSubmitButton ), isEqual );
